
import Markdown from 'react-markdown'
const PrivacyPolicy = () => {

  const markdownEnglish = `# Privacy Policy

  Last updated: December 2, 2025

  This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
  
  We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
  
  We recommend reviewing this privacy statement to get a clearer understanding of your privacy rights and choices. if you do not agree with our policies and practices, please do not use our Services. For any additional questions, don’t hesitate to reach out to us via email at devapp555@outlook.com.
  
  This Privacy Policy has been created with the help of the [Privacy Policy Generator](https://www.termsfeed.com/privacy-policy-generator/).
  
  

  # Interpretation and Definitions
  
  ## Interpretation
  
  The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
  
  ## Definitions
  
  For the purposes of this Privacy Policy:
  
  - __Account__ means a unique account created for You to access our Service or parts of our Service.
  - __Affiliate__ means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.
  
  - __Application__ refers to Evtimkr, the software program provided by the Company.
  
  
  
  - __Company__ (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Evtimkr.
  
  
  
  - __Country__ refers to:  Israel
  
  - __Device__ means any device that can access the Service such as a computer, a cellphone or a digital tablet.
  
  
  
  - __Personal Data__ is any information that relates to an identified or identifiable individual.
  
  
  
  
  - __Service__ refers to the Application.
  
  - __Service Provider__ means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.
    
  
  - __Usage Data__ refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
  
  
  - __You__ means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
  
  
  
  # Collecting and Using Your Personal Data
  
  ## Types of Data Collected
  
  ### Personal Data
  
  While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
  
  - Usage Data
  

  ### Usage Data
  
  Usage Data is collected automatically when using the Service.

  Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
  
  When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
  
  We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
  
  
  ### Payments
  We may offer paid products or services within the Service. Payments are processed by third-party payment providers. Your payment card details are not stored or collected by us. This information is provided directly to the payment processors, who handle your personal information in accordance with their Privacy Policy.

  You may find their privacy notice link(s) here:

  [Payments via Apple Store In-App Purchases](https://www.apple.com/legal/privacy/en-ww/).
  (https://www.apple.com/legal/privacy/en-ww/)

  
### Log Data

We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.


### Cookies

Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.

This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.


### Service Providers

We may employ third-party companies and individuals due to the following reasons:

- To facilitate our Service;

- To provide the Service on our behalf;

- To perform Service-related services; or

- To assist us in analyzing how our Service is used.

We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.

### Hosting
This website is hosted on Netlify. As part of providing hosting, Netlify may collect technical usage data (such as IP address, browser type, device information, and operating system) as described in their Privacy Policy. 

We do not collect or control this data, its handling is governed by Netlify’s policy.  

[Netlify Privacy Policy](https://www.netlify.com/privacy).
  (https://www.netlify.com/privacy)

### Accessibility Widget
This website uses the Sienna Accessibility Widget, which helps display an accessibility button on the site.

When the widget loads, the script is fetched from jsDelivr. As with any request to an external service, basic technical usage data (such as IP address, browser type, device information, and operating system) may be transmitted. Where necessary, any actions you take within the widget are processed to allow it to function properly.
A technically necessary cookie may also be set to store your accessibility preferences while using the widget.

[jsdelivr Privacy Policy](https://www.jsdelivr.com/terms/privacy-policy).
  (https://www.jsdelivr.com/terms/privacy-policy)

For more information, [https://accessibility-widget.pages.dev](https://accessibility-widget.pages.dev)

  ## Use of Your Personal Data
  
  The Company may use Personal Data for the following purposes:
  
  - __To provide and maintain our Service__, including to monitor the usage of our Service.
  - __To manage Your Account:__ to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.
  - __For the performance of a contract:__ the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.
  - __To contact You:__ To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.
  - __To provide You__ with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.
  - __To manage Your requests:__ To attend and manage Your requests to Us.
  
  - __For business transfers:__ We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.
  - __For other purposes__: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience. 
  
  We may share Your personal information in the following situations:
  
  - __With Service Providers:__ We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.
  - __For business transfers:__ We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.
  - __With Affiliates:__ We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.
  - __With business partners:__ We may share Your information with Our business partners to offer You certain products, services or promotions.
  - __With other users:__ when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. 
  - __With Your consent__: We may disclose Your personal information for any other purpose with Your consent.
  
  ## Retention of Your Personal Data
  
  The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
  
  The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
  
  ## Transfer of Your Personal Data
  
  Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
  
  Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
  
  The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.
  
  ## Delete Your Personal Data
  
  You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
  
  Our Service may give You the ability to delete certain information about You from within the Service.
  
  You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
  
  Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.
  
  ## Disclosure of Your Personal Data
  
  ### Business Transactions
  
  If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
  
  ### Law enforcement
  
  Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
  
  ### Other legal requirements
  
  The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
  
  - Comply with a legal obligation
  - Protect and defend the rights or property of the Company
  - Prevent or investigate possible wrongdoing in connection with the Service
  - Protect the personal safety of Users of the Service or the public
  - Protect against legal liability
  
  ## Security of Your Personal Data
  
  The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
  
  # Data protection rights

  Our Company would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:

  __The right to access__ – You have the right to request Our Company for copies of your personal data. We may charge you a small fee for this service.
  
  __The right to rectification__ – You have the right to request that Our Company correct any information you believe is inaccurate. You also have the right to request Our Company to complete the information you believe is incomplete.
  
  __The right to erasure__ – You have the right to request that Our Company erase your personal data, under certain conditions.
  
  __The right to restrict processing__ – You have the right to request that Our Company restrict the processing of your personal data, under certain conditions.
  
  __The right to object to processing__ – You have the right to object to Our Company’s processing of your personal data, under certain conditions.
  
  __The right to data portability__ – You have the right to request that Our Company transfer the data that we have collected to another organization, or directly to you, under certain conditions.
  
  If you make a request, we have one month to respond to you. Please note that we may ask You to verify Your identity before responding to such requests. If you would like to exercise any of these rights, please contact us at our email: devapp555@outlook.com

 # CCPA Privacy Rights (Do Not Sell My Personal Information)
 Under the CCPA, among other rights, California consumers have the right to:

 Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.
 
 Request that a business delete any personal data about the consumer that a business has collected.
 
 Request that a business that sells a consumer's personal data, not sell the consumer's personal data.
 
 If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.

 # GDPR Data Protection Rights
 We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:

 The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.
 
 The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.
 
 The right to erasure – You have the right to request that we erase your personal data, under certain conditions.
 
 The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.
 
 The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.
 
 The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.
 
 If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.

  # "Do Not Track" signals
  We do not support Do Not Track ("DNT") signals. 

  However, some third-party services may still track your activity. If you are using such services, you can adjust your browser settings to request that websites do not track you. You can enable or disable DNT in your browser’s preferences or settings.
    
 # Clarification Regarding Data Collection
 We want to emphasize that our app does not collect, store, or process any personal data on our servers. All data is stored locally on the user's device and is not transmitted or stored outside of the device. We do not have access to the content of your event data or any other personal data stored on your device. The app only stores data locally, and as a result, the rights outlined under CCPA and GDPR, such as the right to request access or deletion of personal data, do not directly apply to this app.

 However, we are committed to transparency and user trust, which is why we include this section to inform you about your general privacy rights.
 
 You have full control over the data saved in the app and can manage or delete it through the app's settings.
 
 If you have any questions or concerns regarding your privacy, please contact us at: devapp555@outlook.com
 
  # Children's Privacy
  
  Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.
  
  If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.
  
  
  # Links to Other Websites
  
  Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
  
  We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
  
  # Translation Interpretation

  These Privacy Policy may have been translated if We have made them available to You on our Service. You agree that the original English text shall prevail in the case of a dispute.

  
  # Changes to this Privacy Policy
  
  We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
  
  We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
  
  You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
  
  # Contact Us
If you have any questions about these Terms and Conditions, You can contact us:

By email: devapp555@outlook.com

`

  return (
    <>
     <div className="padding-page">

     <Markdown>{markdownEnglish}</Markdown>
      </div>
      <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUse'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
    </>
  );
}

export default PrivacyPolicy;